export default __webpack_public_path__ + "static/media/grisinne.b58b8fd6.png";